
import { api_host,api_auth} from '../../common/globals/constants';

export const getBaseElements = (objective, monitor, begin, final, token, id_user) => 
fetch(api_host+`/reporte/online/indicadores/getBaseElementsPlus/?objetivoId=${objective}&token=${token}&fechaInicio=${begin}&fechaTermino=${final}&monitor_id=${monitor}&user=${id_user}`)
.then(response => response.json())
